import { findBy, findAllBy } from "./base";

const TIME_SLOTS = ["time_slots", "time_slots"];

export const timeSlot = (state) => (id) => findBy(state)(TIME_SLOTS, { id });

export const timeSlotsForProject = (state) => (project_id) =>
  findAllBy(state)(TIME_SLOTS, { project_id });
